module.exports = __webpack_public_path__ + "static/media/plane.c7aec9cf.svg";